<template>
  <table-page :headers="headers" :items="items" :rowCount="25" />
</template>
<script>
import TablePage from "../../../components/TablePage.vue";
export default {
  components: {
    TablePage,
  },
  data() {
    return {
      headers: [
        {
          text: "Title",
          align: "start",
          value: "title",
        },
        { text: "Abbreviation", value: "abbreviation" },
        { text: "Description", value: "description" },
        { text: "Created Date", value: "createdDate" },
        { text: "Created By", value: "creatorAccount" },
      ],
      items: [
        {
          title: "Device 1",
          abbreviation: "D1",
          description: "device 1 description",
        },
        {
          title: "Device 2",
          abbreviation: "D2",
          description: "device 2 description",
        },
        {
          title: "Device 3",
          abbreviation: "D3",
          description: "device 3 description",
        },
      ],
    };
  },
};
</script>
<style>
.text-start {
  font-size: 14px !important;
}
.td.text-start {
  font-size: 13px !important;
  height: 48px;
}
</style>